"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTransitionsCompletedSymbol = exports.PageFeatureLoaderSym = exports.PageResourceFetcherSymbol = exports.CssFetcherSymbol = exports.PageAssetsLoaderSymbol = exports.contextIdSymbol = exports.pageIdSym = void 0;
exports.pageIdSym = Symbol('pageId');
exports.contextIdSymbol = Symbol('contextId');
exports.PageAssetsLoaderSymbol = Symbol('PageAssetsLoaderSymbol');
exports.CssFetcherSymbol = Symbol('CssFetcher');
exports.PageResourceFetcherSymbol = Symbol('PageResourceFetcher');
exports.PageFeatureLoaderSym = Symbol('PageFeatureLoader');
exports.PageTransitionsCompletedSymbol = Symbol('PageTransitionsCompleted');
//# sourceMappingURL=page.js.map